import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import '@/index.css'

const RootErrorFallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
    <div className="max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm">
      <h1 className="text-xl font-semibold text-slate-900">
        Something went wrong
      </h1>
      <p className="mt-2 text-sm text-slate-600">
        Refresh the admin app to continue.
      </p>
      <button
        type="button"
        className="mt-4 rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
        onClick={() => window.location.reload()}
      >
        Refresh page
      </button>
    </div>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<RootErrorFallback />}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
